import { format, startOfDay } from 'date-fns';

import { MEASUREMENT_UNITS_BY_PARAMETER } from '../../shared/constants/user-measurements';
import {
  IUserMeasurement,
  MeasurementParameter,
  MeasurementUnitKey,
} from '../../types/interfaces/user-measurement';

export function getTodayMeasuredDate(): string {
  return format(startOfDay(new Date()), 'yyyy-MM-dd');
}

export function findLatestMeasurement(
  measurements: IUserMeasurement[] | undefined | null,
  parameter: MeasurementParameter,
): IUserMeasurement | undefined {
  if (!measurements?.length) {
    return undefined;
  }

  const matching = measurements.filter(
    (measurement) => measurement.parameter === parameter,
  );

  if (!matching.length) {
    return undefined;
  }

  return [...matching].sort((a, b) => {
    const dateCompare = b.measuredDate.localeCompare(a.measuredDate);

    if (dateCompare !== 0) {
      return dateCompare;
    }

    return b.createdAt.localeCompare(a.createdAt);
  })[0];
}

export function formatMeasurementDisplay(
  measurement: IUserMeasurement | undefined | null,
  notSetLabel: string,
): string {
  if (!measurement) {
    return notSetLabel;
  }

  return `${measurement.value} ${measurement.unit}`;
}

export function getUnitsForParameter(
  parameter: MeasurementParameter,
): MeasurementUnitKey[] {
  return MEASUREMENT_UNITS_BY_PARAMETER[parameter];
}
